import React, {useEffect, useState} from "react";
import {Form, Select} from "antd"
import {CustomInput} from "../../Custom/Input";
import {CustomSelect} from "../../Custom/Select";
// @ts-ignore
import {useDebounce} from "use-lodash-debounce"
import {useTranslation} from "react-i18next";
import apiNsi from "../../../api/nsi";
import {NsiItem} from "../../../api/types";

const AddressInput = (props: any) => {
    const {t} = useTranslation(['resources', 'translation'])
    const {
        form,
        address,
        disabled,
        isLegalEntityRB,
    } = props
    const [country, setCountry] = useState("")
    const inputCountry = useDebounce(country, 750)
    const [countries, setCountries] = useState<NsiItem[]>([])
    const [selectCountry, setSelectCountry] = useState<NsiItem>()

    useEffect(() => {
        searchCountry(inputCountry)
    }, [inputCountry])

    function searchCountry(value: string){
        if (value && value.trim().length >= 2){
            let name = value.trim()
            apiNsi.getCountryByName(name)
                .then((res) => {
                    if (res.code === 200){
                        setCountries(res.data)
                    }
                })
        }
        else
            setSelectCountry(undefined)
    }

    /*function handleChangeCountry(val: number){
        let selectedCountry = undefined
        if (countries) {
            selectedCountry = countries.find((value: NsiItem) => {
                return value.id === val
            })
        }
        setSelectCountry(selectedCountry)
    }*/

    return (
    <div className="new-block">
        <Form.Item
            hidden={isLegalEntityRB}
            label={t('ClientCountry')}
            name="countryId"
            rules={[
                ({ getFieldValue }) => ({
                    validator(rule, value){
                        let clientCode = getFieldValue("clientTypeCode")
                        if (!value && clientCode === 20)
                            return Promise.reject(t('validation:RequiredField'))
                        return Promise.resolve()
                    }
                })
            ]}
        >
            <CustomSelect
                showSearch
                defaultActiveFirstOption={false}
                disabled={Boolean(disabled)}
                filterOption={false}
                notFoundContent={null}
                placeholder={t('CountryPlaceholder')}
                style={{
                    width: "100%"
                }}
                /*value={selectCountry?.id}*/
                /*onChange={handleChangeCountry}*/
                onSearch={(value: string) => setCountry(value)}
            >
                {countries.map((value) => {
                    return (
                        <Select.Option key={value.id} style={{width: "100%"}} title={value.name} value={value.id}>{value.name}</Select.Option>
                    )
                })}
            </CustomSelect>
        </Form.Item>
        <Form.Item
            initialValue={ address ? address.postIndex : null }
            label={t('AppUserPostIndex')}
            name="postIndex"
            normalize={(word) => (word ? word : null)}
            rules={[
                {
                    required : true,
                    message : t('validation:RequiredField')
                },
                {
                    pattern  : /^[a-zA-Z0-9-]{4,7}$/,
                    message : t('validation:ValidatePostIndex')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={20}
                placeholder={t('AppUserPostIndex')}
            />
        </Form.Item>
        <Form.Item
            initialValue={address ? address.oblast : null}
            label={t('AppUserModelOblast')}
            name="oblast"
            normalize={(word) => (word ? word : null)}
            rules={[
                {
                    min: 3,
                    max : 60,
                    message : t('validation:LengthErr')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={150}
                placeholder={t('AppUserModelOblast')}
            />
        </Form.Item>
        <Form.Item
            initialValue={address ? address.raion : null}
            label={t('AppUserModelRaion')}
            name="raion"
            normalize={(word) => (word ? word : null)}
            rules={[
                {
                    min: 3,
                    max : 60,
                    message : t('validation:LengthErr')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={150}
                placeholder={t('AppUserModelRaion')}
            />
        </Form.Item>
        <Form.Item
            initialValue={address ? address.city : null}
            label={t('ApplicationUserCity')}
            name="city"
            normalize={(word) => (word ? word : null)}
            rules={[
                {
                    required : true,
                    message : t('validation:RequiredField')
                },
                {
                    min: 3,
                    max : 60,
                    message : t('validation:LengthErr')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={150}
                placeholder={t('ApplicationUserCity')}
            />
        </Form.Item>
        <Form.Item
            initialValue={address ? address.address : null}
            label={t('AppUserModelAddress')}
            name="address"
            normalize={(word) => (word ? word : null)}
            rules={[
                {
                    min: 3,
                    max : 256,
                    message : t('validation:LengthErr')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={300}
                placeholder={t('AppUserModelAddress')}
            />
        </Form.Item>
        <Form.Item
            initialValue={address ? address.street : null}
            label={t('ClientStreet')}
            name="street"
            normalize={(word) => (word ? word : null)}
            rules={[
                {
                    required : true,
                    message : t('validation:RequiredField')
                },
                {
                    min: 3,
                    max : 60,
                    message : t('validation:LengthErr')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={150}
                placeholder={t('ClientStreet')}
            />
        </Form.Item>
        <Form.Item
            initialValue={address ? address.building : null}
            label={t('ClientBuilding')}
            name="building"
            normalize={(word) => (word ? word : null)}
            rules={[
                {
                    required : true,
                    message : t('validation:RequiredField')
                },
                {
                    min : 1,
                    max : 10,
                    message : t('validation:LengthErr')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={50}
                placeholder={t('ClientBuilding')}
            />
        </Form.Item>
        <Form.Item
            initialValue={address ? address.apartment : null}
            label={t('ClientFlat')}
            name="apartment"
            normalize={(word) => (word ? word : null)}

            rules={[
                {
                    required : true,
                    message : t('validation:RequiredField')
                },
                {
                    pattern : /^[0-9][a-zA-Z0-9]{0,10}$/,
                    message : t('validation:ValidateAptAndBuilding')
                }
            ]}
        >
            <CustomInput
                allowClear
                autoComplete="off"
                disabled={Boolean(disabled)}
                maxLength={50}
                placeholder={t('ClientFlat')}
            />
        </Form.Item>
    </div>
    )
}

export default AddressInput